import EventBus from '@/util/eventBus';

export default {
	methods: {
		scrollTo(id) {
			EventBus.$emit('scrollTo', id);
		},
	},
};
